import _ from 'lodash'
import { ProductionDistance } from '../../../../../../types/OrganizationUnit'
import { SplitOption } from '../../../../../../types/Survey/Analysis/Calculation'
import { Concept, ConceptValues } from '../../../../../../types/Survey/Analysis/Concept'
import { isUnitAllowedByFloor } from '../SummaryFloor'
import { isUnitAllowedByProductionDistance } from '../SummaryProductionDistance'

const getCombinedUnitsBasedOnSplitType = (concept: Concept, productionDistance: ProductionDistance, floorUUID: string): ConceptValues[] => {
  const getOriginUnitUUID = (unitUUID: string): string => {
    if (concept.units[unitUUID].originUnitUUID === unitUUID) {
      return unitUUID
    }
    return getOriginUnitUUID(concept.units[unitUUID].originUnitUUID)
  }

  const unitUUIDList = Object.keys(concept.units).filter(
    (unitUUID) =>
      unitUUID !== 'sum' &&
      isUnitAllowedByProductionDistance(concept, unitUUID, productionDistance) &&
      isUnitAllowedByFloor(concept, unitUUID, floorUUID),
  )

  const groupUnitsByOriginUnitUUID = unitUUIDList.reduce((acc, unitUUID) => {
    // origin units where the originUnitUUID is the same as the unitUUID,
    // hard split units and legacy units without a splitOption are treated as origin units
    if (
      concept.units[unitUUID].originUnitUUID === unitUUID ||
      concept.units[unitUUID].splitOption === SplitOption.HARD ||
      concept.units[unitUUID].splitOption === null
    ) {
      if (acc[unitUUID]) {
        acc[unitUUID].push(concept.units[unitUUID])
      } else {
        acc[unitUUID] = [concept.units[unitUUID]]
      }
    } else if (concept.units[unitUUID].splitOption === SplitOption.SOFT) {
      const originUnitUUID = getOriginUnitUUID(unitUUID)
      if (acc[originUnitUUID]) {
        acc[originUnitUUID].push(concept.units[unitUUID])
      } else {
        acc[originUnitUUID] = [concept.units[unitUUID]]
      }
    }
    return acc
  }, {})

  const combinedUnits = Object.values(groupUnitsByOriginUnitUUID).map((units: ConceptValues[]) => {
    if (units.length === 1) return units[0]

    const originUnit = _.cloneDeep(units.find((unit) => unit.originUnitUUID === unit.unitUUID))

    originUnit.anwesenheitPercentage.percentage =
      _.sum(units.map((unit) => unit.anwesenheitPercentage.percentage * unit.mitarbeiter)) / _.sum(units.map((unit) => unit.mitarbeiter))

    originUnit.desksharingPercentage.percentage =
      _.sum(units.map((unit) => unit.desksharingPercentage.percentage * unit.mitarbeiter)) / _.sum(units.map((unit) => unit.mitarbeiter))

    originUnit.mitarbeiter = _.sum(units.map((unit) => unit.mitarbeiter))
    originUnit.originalMitarbeiter = _.sum(units.map((unit) => unit.originalMitarbeiter))

    return originUnit
  })

  return combinedUnits
}

export default getCombinedUnitsBasedOnSplitType
